export enum AuthLoaders {
  Login
}
